import { client } from '@/services/api/axios.ts';
import { useQuery } from '@tanstack/react-query';
import { TPlant } from '@/features/plants/schemas/plants.schema.ts';

export type PlantsWithOverview = TPlant & {
  totalYield: number | undefined;
  yieldToday: number | undefined;
  consumptionToday: number | undefined;
  fedToGrid: number | undefined;
  batteryStateOfCharge: number | undefined;
  batteryStatus: string | undefined;
  batteryChargePowerToday: number | undefined;
  batteryDischargePowerToday: number | undefined;
  mqttStatus: number | undefined;
};

export type GetPlantsResponse<T extends boolean> = T extends true
  ? PlantsWithOverview[]
  : TPlant[];

export const useGetPlantsQuery = <T extends boolean>(
  { includeOverview, enabled }: { includeOverview?: T; enabled?: boolean } = {
    includeOverview: false as T,
    enabled: true,
  }
) => {
  const queryKey = includeOverview ? ['plants', 'overview'] : ['plants'];

  return useQuery({
    queryKey,
    queryFn: async () => {
      if (includeOverview) {
        const { data } = await client.get<{ body: GetPlantsResponse<T> }>(`/plants`, {
          params: {
            includeOverview: String(includeOverview),
          },
        });
        return data.body;
      }

      const { data } = await client.get<{ body: GetPlantsResponse<T> }>(`/plants`);
      return data.body;
    },
    enabled,
    staleTime: includeOverview ? 60 * 1000 : 5 * 60 * 1000,
  });
};
